import React from "react";
import Folder from "../Folder/Folder";
import AppContext from "../../AppContext";
import { Link } from "react-router-dom";
import config from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


class FolderList extends React.Component {
  static contextType = AppContext;

  handleDeleteFolder = folderId => {
    fetch(`${config.API_ENDPOINT}folders/${folderId}/`, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${config.API_KEY}`
      }
    })
      .then(resp => {
        if (!resp.ok) {
          throw new Error("Something went wrong!");
        }
      })
      .then(() => {
        if (this.props.history) {
          this.props.history.push("/");
        }
        this.context.handleDeleteFolder(folderId);
      })
      .catch(error => {
        console.log(error.message);
      });
  };

  // handleEditFolder = folderId => {
  //   fetch(`${config.API_ENDPOINT}folders/${folderId}/`, {
  //     method: "PUT",
  //     headers: {
  //       "content-type": "application/json",
  //       Authorization: `Bearer ${config.API_KEY}`
  //     }
  //   })
  //     .then(resp => {
  //       if (!resp.ok) {
  //         throw new Error("Something went wrong!");
  //       }
  //     })
  //     .then(() => {
  //       if (this.props.history) {
  //         this.props.history.push("/");
  //       }
  //       this.context.handleEditFolder(folderId);
  //     })
  //     .catch(error => {
  //       console.log(error.message);
  //     });
  // };

  getJsxFolders = folders => {
    return folders.map(folder => {
      return (
        <li key={folder.id}>
          <Folder folder={folder} />
          {/* <button
            className="edit"
            // onClick={() => this.handleEditFolder(folder.id)}
          >
            <FontAwesomeIcon className='editIcon' icon='edit'/>
          </button> */}
          <button
            className="deleteIcon"
            onClick={() => this.handleDeleteFolder(folder.id)}
          >
            <FontAwesomeIcon icon='trash'/>
          </button>
        </li>
      );
    });
  };

  render() {
    const { folders = [] } = this.context;
    return (
      <>
        <ul>{this.getJsxFolders(folders)}</ul>
        <Link to="/addfolder">
          <button id="AddFolder">Add Folder</button>
        </Link>
      </>
    );
  }
}

// FolderList.defaultProps = {
//   folders: [],
// };

export default FolderList;
